import { useEffect, useState } from "react";
import { Bar } from "react-chartjs-2";
import { useTheme } from "@mui/material";

export const BarChart_TicketClosed = ({ ticketClosed = [], datalabels }) => {
  const theme = useTheme();
  const [data, setData] = useState(null);

  const setLocalTicketClosed = () => {
    const bgList = [
      "#aaaaaa",
      "#484848",
      "#ffe200",
      "#ba68c8",
      "#4caf50",
      "#F97427",
      "#0343C7",
    ];

    //only use the last n of array
    bgList.splice(0, 7 - ticketClosed.length);

    ticketClosed.sort(function (x, y) {
      return x.ClosedTime < y.ClosedTime ? -1 : 1;
    });

    setData({
      datasets: [
        {
          backgroundColor: bgList,
          barPercentage: 0.5,
          barThickness: 35,
          borderRadius: 4,
          categoryPercentage: 0.5,
          data: ticketClosed.map((x) => x.CountTicket),
          label: "",
          maxBarThickness: 40,
        },
      ],

      labels: ticketClosed.map((x) => x.DaysName),
    });
  };

  const options = {
    cornerRadius: 20,
    layout: { padding: 0 },
    plugins: { datalabels, legend: { display: false } },
    maintainAspectRatio: false,
    responsive: true,

    xAxes: [
      {
        gridLines: {
          display: false,
          drawBorder: false,
        },
      },
    ],

    yAxes: [
      {
        ticks: {
          fontColor: theme.palette.text.secondary,
          beginAtZero: true,
          min: 0,
        },

        gridLines: {
          borderDash: [2],
          borderDashOffset: [2],
          color: theme.palette.divider,
          drawBorder: false,
          zeroLineBorderDash: [2],
          zeroLineBorderDashOffset: [2],
          zeroLineColor: theme.palette.divider,
        },
      },
    ],

    tooltips: {
      backgroundColor: theme.palette.background.paper,
      bodyFontColor: theme.palette.text.secondary,
      borderColor: theme.palette.divider,
      borderWidth: 1,
      enabled: true,
      footerFontColor: theme.palette.text.secondary,
      intersect: false,
      mode: "index",
      titleFontColor: theme.palette.text.primary,
    },
  };

  useEffect(() => {
    setLocalTicketClosed();
  }, [ticketClosed]);

  return (
    <div style={{ height: 380, paddingTop: 10, paddingBottom: 10 }}>
      {data ? <Bar data={data} options={options} /> : ""}
    </div>
  );
};

export default BarChart_TicketClosed;
